var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logo)?_c('a',{class:['logoMenuItem logo-' + _vm.logo.TypeSettings.LogoPosition],attrs:{"href":_vm.logo.TypeSettings.LinkSettings.Value,"target":_vm.logo.TypeSettings.LinkSettings.Target}},[_c('img',{style:({width: _vm.logo.TypeSettings.LogoImageSize}),attrs:{"src":_vm.getLogoCdn(_vm.logo.TypeSettings.LogoUrl)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }